import { PositionType } from "@cosine/types/api-models";

export const stockTypes = Object.freeze([
  PositionType.CommonStock,
  PositionType.ETF,
  PositionType.PreferredStock,
]);
